/* eslint-disabled */

const MessageBoxType = {
  ERROR: 0,
  INFO: 1,
  SUCCESS: 2,
  WARNING: 3,
}

const MessageBoxVariant = {
  NORMAL: 'normal', // Regular popup (type 0)
  DRAGGABLE: 'draggable', // Draggable popup
  NOTICE: 'notice', // Notice popup for confirmations
}

const MessageBoxContent = ({
  type,
  buttons,
  title = '',
  subTitle = '',
  description = '',
  note = '',
  component,
  draggable = false,
  hideCloseButton = false,
  maxWidth,
  maxHeight,
  callback,
  variant = MessageBoxVariant.NORMAL, // New variant property
}) => {
  return {
    type,
    buttons,
    title,
    subTitle,
    description,
    note,
    component,
    draggable,
    callback,
    hideCloseButton,
    maxWidth,
    maxHeight,
    variant,
  }
}

export { MessageBoxType, MessageBoxVariant }
export default MessageBoxContent

/* eslint-enabled */
